


const Analytics = {
    gtag() {
        dataLayer.push(arguments);
        // console.log("arguments", arguments)
    }
}

export default Analytics;

